<div class="organization-unit-customer-form">
  <form [formGroup]="form">
    <div class="customer-details-section">
      <div class="addresses flex-col gap-8">
        <div class="address-column">
          <h4>{{ 'organization_unit_details.delivery_address.heading' | translate }}</h4>
          <mat-form-field [appearance]="inputAppearance">
            <mat-label>{{ 'organization_unit.address.label' | translate }}</mat-label>
            <input formControlName="address" matInput [errorStateMatcher]="errorStateMatcher" />
            @if (form.get('address')?.hasError('required')) {
              <mat-error>{{ 'generic.form.required_field' | translate }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field [appearance]="inputAppearance">
            <mat-label>{{ 'organization_unit.postal_code.label' | translate }}</mat-label>
            <input formControlName="postalcode" matInput [errorStateMatcher]="errorStateMatcher" />
            @if (form.get('postalcode')?.hasError('required')) {
              <mat-error>{{ 'generic.form.required_field' | translate }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field [appearance]="inputAppearance">
            <mat-label>{{ 'organization_unit.city.label' | translate }}</mat-label>
            <input formControlName="city" matInput [errorStateMatcher]="errorStateMatcher" />
            @if (form.get('city')?.hasError('required')) {
              <mat-error>{{ 'generic.form.required_field' | translate }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field [appearance]="inputAppearance">
            <mat-label>{{ 'organization_unit.country.label' | translate }}</mat-label>
            <input formControlName="country" matInput [errorStateMatcher]="errorStateMatcher" />
            @if (form.get('country')?.hasError('required')) {
              <mat-error>{{ 'generic.form.required_field' | translate }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field [appearance]="inputAppearance">
            <mat-label>{{ 'organization_unit.email.label' | translate }}</mat-label>
            <input formControlName="email" matInput type="email" [errorStateMatcher]="errorStateMatcher" />
            @if (form.get('email')?.hasError('required')) {
              <mat-error>{{ 'generic.form.required_field' | translate }}</mat-error>
            }
            @if (form.get('email')?.hasError('email')) {
              <mat-error>{{ 'generic.form.invalid_email' | translate }}</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="address-column">
          <h4>{{ 'organization_unit_details.billing_address.heading' | translate }}</h4>
          <mat-form-field [appearance]="inputAppearance">
            <mat-label>{{ 'organization_unit.address.label' | translate }}</mat-label>
            <input formControlName="billing_address" matInput />
          </mat-form-field>
          <mat-form-field [appearance]="inputAppearance">
            <mat-label>{{ 'organization_unit.postal_code.label' | translate }}</mat-label>
            <input formControlName="billing_postalcode" matInput />
          </mat-form-field>
          <mat-form-field [appearance]="inputAppearance">
            <mat-label>{{ 'organization_unit.city.label' | translate }}</mat-label>
            <input formControlName="billing_city" matInput />
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</div>
